export default __webpack_public_path__ + "static/media/3435 spice rack F side.ddc12748.png";